export default "__VITE_ASSET__BCTj2T9f__"